/*
 * START_MODULE_CONTRACT
 *   PURPOSE: Yandex OAuth login button — redirects to oauth.yandex.ru/authorize
 *   PROPS:   className (optional)
 *   STATE:   none
 *   DEPENDS: M-CN (cn utility)
 *   EMITS:   none — full-page redirect to Yandex OAuth
 *   ACCESSIBILITY: Native button with focus-visible, min 44px touch target
 *   LINKS:   M-YDX
 * END_MODULE_CONTRACT
 *
 * CHANGE_SUMMARY
 *   [2026-06-13] Rewritten — direct oauth.yandex.ru redirect with official styling
 *                          (removed YaAuthSuggest SDK — blocked by CSP/adblockers)
 */

"use client"

import { usePathname } from "next/navigation"
import { cn } from "@/lib/cn"

const YANDEX_CLIENT_ID =
  process.env.NEXT_PUBLIC_YANDEX_CLIENT_ID || "c5a21aba18784041a2ba1260949584a9"

export function YandexLogin({ className }: { className?: string }) {
  const pathname = usePathname()
  const locale = pathname.split("/")[1] || "en"

  const handleClick = () => {
    const redirectUri = `${window.location.origin}/${locale}/login/yandex/callback`
    window.location.href =
      "https://oauth.yandex.ru/authorize" +
      "?response_type=token" +
      `&client_id=${encodeURIComponent(YANDEX_CLIENT_ID)}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}`
  }

  return (
    <div className={cn("flex justify-center", className)}>
      <button
        type="button"
        onClick={handleClick}
        className="inline-flex h-11 w-full max-w-[252px] items-center justify-center gap-2.5 rounded-full bg-black px-6 text-sm font-semibold text-white hover:bg-neutral-900 active:scale-[0.98] transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20 focus-visible:ring-offset-2 focus-visible:ring-offset-[#1e2329]"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="12" fill="#FC3F1D" />
          <text x="12" y="16" textAnchor="middle" fill="white" fontSize="13" fontWeight="700" fontFamily="Inter, -apple-system, BlinkMacSystemFont, sans-serif">Я</text>
        </svg>
        {locale === "ru" ? "Войти через Яндекс" : "Sign in with Yandex"}
      </button>
    </div>
  )
}
